import { useEffect, useState } from 'react';

export default function useDebounce(value:any, customFunc:()=>void) {
  const [init, setInit] = useState(false);

  useEffect(() => {
    if (!init) {
      setInit((prev) => !prev);
      return () => null;
    }
    const handler = setTimeout(() => {
      customFunc();
    }, 1300);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);
}
